import React from "react";
import logoNavarra from "../../assets/img/logo-gob-navarra-agenda-2030.png";
import logoInm from "../../assets/img/logo-inm.png";

const MapFooter = () => {
  return (
    <footer className="has-background-primary has-text-white map-footer">
      <div className="py-5 px-6 is-flex gap-5">
        <div className="logos is-flex is-align-items-center gap-5">
          <a href="https://www.navarra.es/">
            <img
              loading="lazy"
              src={logoNavarra}
              alt="Gobierno de Navarra. Nafarroako Gobernua. Agenda 2030"
              width="187"
              height="41"
              className="is-block"
            />
          </a>
          <a href="https://pazyconvivencia.navarra.es/es/inm">
            <img
              loading="lazy"
              src={logoInm}
              alt="Instituto Navarro de la Memoria. Nafarroako Memoriaren Institutua"
              width="138"
              height="32"
              className="is-block"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default MapFooter;
